import authService from './auth';
import articleService from './articles';
import commentService from './comments';
import profileService from './profile';
import tagService from './tags';

export { authService, articleService, commentService, profileService, tagService };
